import { io } from 'socket.io-client';

// eslint-disable-next-line import/no-cycle
import router from '@/router';

import { SOCKET_IO } from '@/configs/socket';

import { EVENT_SOCKET, MESSAGE } from '@/store/mutation-types';

const socket = io(SOCKET_IO, { transports: ['websocket'] });

// eslint-disable-next-line no-shadow
function createWebSocketPlugin(socket) {
  return (store) => {
    store.$socket = socket;
    socket.on(EVENT_SOCKET.EVENT_SEND_MESSAGE, (message) => {
      if (message) {
        message.userLoginId = store.state.user.user.parent_id;
        store.dispatch('socket/addMessage', message);
      }
    });
    socket.on(EVENT_SOCKET.EVENT_GET_MESSAGE, (data) => {
      if (data) {
        data.listMessages.userLoginId = store.state.user.user.parent_id;
        store.dispatch('socket/setMessage', data?.listMessages);
        store.dispatch('socket/setTotalPagesMessage', data?.totalPages);
      }
    });
    socket.on(EVENT_SOCKET.EVENT_CREATE_CHANNEL, (data) => {
      if (data) {
        data.userLoginId = store.state.user.user.parent_id;
        store.dispatch('socket/setChannel', data);
      }
    });
    socket.on(EVENT_SOCKET.EVENT_FIND_ALL_CHANNEL, (data) => {
      if (data) {
        data.userLoginId = store.state.user.user.parent_id;
        store.dispatch('socket/setAllChannel', data);
      }
    });
    socket.on(EVENT_SOCKET.EVENT_FIND_CHANNEL, (data) => {
      if (data) {
        store.dispatch('socket/getInfoChannel', data);
      } else {
        router.push({ name: 'NotFound' });
      }
    });
    socket.on(EVENT_SOCKET.EVENT_UPDATE_STATUS_CHANNEL, (data) => {
      if (data) {
        data.userLoginId = store.state.user.user.parent_id;
        store.dispatch('socket/updateChannel', data);
        store.dispatch('socket/getInfoChannel', data);
      } else {
        router.push({ name: 'NotFound' });
      }
    });
    socket.on(EVENT_SOCKET.EVENT_UPDATE_CHANNEL, (data) => {
      if (data) {
        data.userLoginId = store.state.user.user.parent_id;
        store.dispatch('socket/updateChannel', data);
        store.dispatch('socket/getInfoChannel', data);
      }
    });
    socket.on(EVENT_SOCKET.EVENT_UPDATE_CHANNEL_MESSAGE, (data) => {
      if (data) {
        data.userLoginId = store.state.user.user.parent_id;
        store.dispatch('socket/updateChannel', data);
      }
    });
    socket.on(EVENT_SOCKET.EVENT_GET_MESSAGE_FROM_DATE, (data) => {
      if (data) {
        data.userLoginId = store.state.user.user.parent_id;
        store.dispatch('socket/setMessage', data);
      }
    });
    socket.on(EVENT_SOCKET.EVENT_GET_CHANNELS_FROM_DATE, (data) => {
      if (data) {
        store.dispatch('socket/loadMoreChannel', data);
      }
    });
    socket.on(EVENT_SOCKET.EVENT_SEARCH_CHANNEL, (data) => {
      if (data) {
        data.userLoginId = store.state.user.user.parent_id;
        store.dispatch('socket/setAllChannel', data);
      }
    });
  };
}

export const websocketPlugin = createWebSocketPlugin(socket);

export default socket;
